import React from 'react';
import PropTypes from 'prop-types';
import classes from './styles';

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    let newLabel = '';
    if (label && typeof label === 'string') {
      newLabel = label.replaceAll('/', '.');
    } else {
      newLabel = label;
    }
    return (
      <div style={classes.customTooltipWrapper}>
        {payload.map(item => (
          <div key={item.name} style={classes.customTooltip}>
            <span style={classes.customTooltipKey}>{item.name}:</span>
            <span style={classes.customTooltipValue}>{item.value}</span>
          </div>
        ))}
        <div style={classes.customTooltipDate}>{`${newLabel}`}</div>
      </div>
    );
  }
  return null;
};

CustomTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.instanceOf(Array),
  label: PropTypes.string,
};

export default CustomTooltip;
